namespace GeniuzPOS.Product {
    export class CsSkuColumns {
        static columnsKey = 'Product.CsSku';
    }
}
